import { useNavigate, useLocation } from 'react-router-dom';
import {
    SucessoContainer,
    MainContent,
    ContentBlock,
    IconWrapper,
    Title,
    Subtitle,
    FooterAction,
    BackButton,
    GlobalStyleSucesso
} from './style';

export function Sucesso() {
    const navigate = useNavigate();
    const location = useLocation();
    const ticketId = (location.state as { ticketId?: number })?.ticketId;

    return (
        <>
            <GlobalStyleSucesso />
            <SucessoContainer>
                {/* Parte que centraliza o ícone e textos */}
                <MainContent>
                    <ContentBlock>
                        <IconWrapper>
                            <svg viewBox="0 0 52 52" fill="none" xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)">
                                <circle cx="26" cy="26" r="25" stroke="#4A6B53" strokeWidth="3" />
                                <path
                                    d="M14 27L22 35L38 19"
                                    stroke="#4A6B53"
                                    strokeWidth="4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </IconWrapper>

                        <Title>Ticket criado com<br />sucesso!</Title>

                        <Subtitle>
                            Ticket #{ticketId || '1'} vinculado com sucesso.
                        </Subtitle>
                    </ContentBlock>
                </MainContent>

                <FooterAction>
                    <BackButton onClick={() => navigate('/modal')}>
                        Voltar a tela inicial
                    </BackButton>
                </FooterAction>
            </SucessoContainer>
        </>
    );
}